import { render, staticRenderFns } from "./InputEditor.vue?vue&type=template&id=0df4e348&scoped=true&"
import script from "./InputEditor.vue?vue&type=script&lang=ts&"
export * from "./InputEditor.vue?vue&type=script&lang=ts&"
import style0 from "./InputEditor.vue?vue&type=style&index=0&id=0df4e348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df4e348",
  null
  
)

export default component.exports